const index = (state, id) => state.data.findIndex((item) => item.id === id)

export default {
	namespaced: true,
	state: {
		data: []
	},
	getters: {
		data: (state) => state.data
	},
	mutations: {
		set(state, payload) {
			state.data = [...payload].sort(this._vm.$compareValues('order'))
		},
		create: (state, data) => state.data.push(data),
		update(state, data) {
			state.data.splice(index(state, data.id), 1, data)
		},
		remove(state, id) {
			state.data.splice(index(state, id), 1)
		}
	},
	actions: {
		async init({ commit }) {
			try {
				const { data } = await this._vm.$axios.get('/image')
				commit('set', data)
			} catch (err) {
				return err
			}
		},
		async update(context, { id, formData }) {
			try {
				const { data } = await this._vm.$axios.patch(`/image/${id}`, formData)
				context.commit('update', data)
				return data
			} catch (err) {
				return err
			}
		},
		async create({ commit }, image) {
			try {
				const { data } = await this._vm.$axios.post('/image', image)
				commit('create', data)
				return data
			} catch (err) {
				return err
			}
		},
		async remove({ commit }, id) {
			try {
				await this._vm.$axios.delete(`/image/${id}`)
				commit('remove', id)
			} catch (err) {
				return err
			}
		},
		updateAll: ({ commit }, data) => commit('set', data)
	}
}
